// Cliente identificado no canto superior DIREITO das telas do totem/balcão:
// "OLÁ, FULANO" + foto do cadastro (ou a inicial) e, com cashback ligado pro
// totem, a carteira com o saldo. Pedido do dono (09/09/2026).
import { Wallet } from "lucide-react";

const fmt = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

export default function ChipCliente({ nome, foto, saldo = null, className = "" }) {
  const n = (nome || "").trim();
  if (!n) return null;
  const primeiro = n.split(/\s+/)[0];
  return (
    <div className={`flex items-center gap-2 ${className}`} data-e2e="chip-cliente">
      {saldo !== null && saldo !== undefined && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/15 border border-primary/30 px-3 py-1.5 text-sm font-bold text-primary" title="Seu cashback" data-e2e="chip-carteira">
          <Wallet className="w-4 h-4" /> {fmt(saldo)}
        </span>
      )}
      <div className="flex items-center gap-2 bg-zinc-800/80 backdrop-blur-sm rounded-full pl-3 pr-1.5 py-1.5">
        <span className="text-sm font-bold text-zinc-100 uppercase tracking-wide" data-e2e="chip-nome">Olá, {primeiro}</span>
        {foto ? (
          <img src={foto} alt={n} className="w-8 h-8 rounded-full object-cover border border-zinc-700" data-e2e="chip-foto" />
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-xs font-bold">{n[0].toUpperCase()}</div>
        )}
      </div>
    </div>
  );
}
